module.exports = __webpack_public_path__ + "static/img/form-2.aaa9496.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/form-2.png
// module id = d5Vh
// module chunks = 46